(function(angular){
	'use strict';
	
	angular.module('hypotheticalPerformanceChartModule', 
		[
			'BaseConfig', 
			'bigModule',
			'countUpModule',
			'highChartsModule'
		]);

})(window.angular);